import React from 'react';
import { PencilIcon, TrashBinIcon, UserIcon } from '../../../assets/icons/icons';
import styles from './RowActions.module.scss';
import { Tooltip } from '../Tooltip/Tooltip';

interface RowActionsProps {
    /* Общий блок действий строки: карточка (необязательно), правка, удаление. */
    /** Не передавайте, если карточки у сущности нет (организации). */
    onOpen?: () => void;
    onEdit: () => void;
    onDelete: () => void;
    openLabel?: string;
}

export function RowActions({ onOpen, onEdit, onDelete, openLabel = 'Карточка пользователя' }: RowActionsProps) {
    return (
        <span className={styles.root}>
            {onOpen && (
                <button type="button" className={styles.action} title={openLabel} aria-label={openLabel} onClick={onOpen}>
                    <UserIcon className={styles.icon} />
                </button>
            )}

            <Tooltip text="Изменить" align="right">
                <button
                    type="button"
                    className={styles.action}
                    aria-label="Изменить"
                    onClick={onEdit}
                >
                    <PencilIcon className={styles.icon} />
                </button>
            </Tooltip>

            <Tooltip text="Удалить" align="right">
                <button
                    type="button"
                    className={`${styles.iconBtn} ${styles.danger}`}
                    aria-label="Удалить"
                    onClick={onDelete}
                >
                    <TrashBinIcon className={styles.icon} />
                </button>
            </Tooltip>
        </span>
    );
}
